import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { useGetConfigurableRemoteConfigurationQuery } from '../../api/remoteConfigurationApiSlice';
import Title from '../Title';
import RemoteConfigurationShow from './RemoteConfigurationShow';
import { Button } from 'react-bootstrap';
import Icon from '../Icon';
import RemoteConfigurationHistory from './RemoteConfigurationHistory';

const RemoteConfiguration = ({configurable}) => {
  const { t } = useTranslation()
  const { data, isLoading, isSuccess, isError } = useGetConfigurableRemoteConfigurationQuery(configurable)
  const history = useHistory();
  const [showModal, setShowModal] = useState(false)

  if ( isLoading ) { return (<></>) }

  return (
    <>
      <Title main={data.configurable_name} sub={t("RemoteConfiguration.title")} onBack={()=>{history.goBack()}}>
        <Button onClick={()=>setShowModal(true)}>
          <Icon icon='timeline' text={t("history")} />
        </Button>
      </Title>
      <RemoteConfigurationShow configuration={data}/>
      <RemoteConfigurationHistory show={showModal} onClose={()=>(setShowModal(false))} configurable={data}/>
    </>
   )
}

export default RemoteConfiguration;